<template>
  <div>
    <v-text-field
      full-width
      style="border-radius: 6px"
      dense
      :background-color="bgColor"
      filled
      :label="label"
      v-model="displayValue"
      readonly
      @click="dialog = true"
    ></v-text-field>

    <v-dialog v-model="dialog" persistent max-width="350px">
      <v-card>
        <v-card-title class="headline">Select Date & Time</v-card-title>

        <v-card-text>
          <v-date-picker v-model="date" @input="step = 2" v-if="step === 1" />
          <v-time-picker
            v-model="time"
            format="24hr"
            v-if="step === 2"
            @click:minute="save"
          />
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn text color="primary" @click="dialog = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "DateTimePicker",
  props: {
    defaultDateTime: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      default: "Select Date & Time",
    },
    bgColor: {
      default: "grey lighten-3",
    },
  },
  data() {
    return {
      dialog: false,
      step: 1,
      date: new Date().toJSON().substring(0, 10),
      time: new Date().toLocaleTimeString(),
    };
  },
  computed: {
    displayValue() {
      return this.formatDateTime(this.date, this.time);
    },
  },
  watch: {
    defaultDateTime: {
      immediate: true,
      handler(val) {
        if (val) {
          const [date, time] = val.split(" ");
          this.date = date;
          this.time = (time && time.substring(0, 5)) || null;
          //this.time = time?.substring(0, 5) || null;
        }
      },
    },
  },
  methods: {
    formatDateTime(date, time) {
      if (!date || !time) return "";
      return `${date} ${time}:00`;
    },
    save() {
      const formatted = this.formatDateTime(this.date, this.time);
      this.$emit("date-time-picked", formatted);
      this.dialog = false;
      this.step = 1;
    },
  },
};
</script>
